import { render, staticRenderFns } from "./ShopStorePayChannel.vue?vue&type=template&id=c331efba&scoped=true"
import script from "./ShopStorePayChannel.vue?vue&type=script&lang=js"
export * from "./ShopStorePayChannel.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayChannel.vue?vue&type=style&index=0&id=c331efba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c331efba",
  null
  
)

export default component.exports